export default "__VITE_ASSET__CmwRXp_y__"